// extracted by mini-css-extract-plugin
module.exports = {"component":"SearchForm_component__Q_axF"};